import { Injectable } from '@angular/core';
import { StageService } from './stage.service';
import { SceneUtilsService } from './scene-utils.service';
import { ComponentBase } from '../component-base';
declare var THREE: any;
import { element } from 'protractor';
import { WallBuilderService } from './wall/wall-builder.service';
import {AutoScaleSprite} from '../custom/AutoScaleSprite';

@Injectable()
export class RemoveWindowsDoorsService extends ComponentBase {

  constructor(
    private stage: StageService,
    private sceneUtils: SceneUtilsService,
    private wallBuilderService: WallBuilderService
  )
  {
    super();
    this.disable();
  }

  loader = new THREE.TextureLoader();
  sprites: any = [];
  private raycaster: any = new THREE.Raycaster();

  drawSprites(){
  let walls = this.stage.getWalls();
  let windowsDoors = [];
  walls.forEach(wall => {
    if(wall.children.length){
      wall.children.forEach( child =>{
        windowsDoors.push(child)
      })
    }
  })

  let i: number = 0;
  windowsDoors.forEach( obj => {
      let spriteMap = this.loader.load('../../assets/images/sprites/remove.png');

      var spriteMaterial = new THREE.SpriteMaterial({ map: spriteMap, color: 0xffffff, depthTest: false, depthWrite: false });

      var sprite = new AutoScaleSprite(50, 50, spriteMaterial);
      sprite.userData.obj = obj;
      this.sprites.push(sprite);
      let pos = obj.getWorldPosition(new THREE.Vector3());
      this.sprites[i].position.copy(pos);
      this.stage.add(this.sprites[i]);
      i++;
  })

  // console.log(this.sprites);
  this.enable();
  }

  mouseDown(e) {
    let p = this.sceneUtils.getRay(e.offsetX, e.offsetY);
    this.raycaster.ray.origin.copy(p.ray.origin);
    this.raycaster.ray.direction.copy(p.ray.direction);
    var intersection = this.raycaster.intersectObjects(this.sprites);

    if (intersection.length) {
      let obj = intersection[0].object;
      let wallConfing = obj.userData.obj.parent.userData.config;
      obj.userData.obj.parent.remove(obj.userData.obj);
      this.wallBuilderService.createWall(wallConfing);
      this.disable();
    }
    else{
      this.disable();
    }
  }

  disable() {
    this.removeSprites();
    super.disable();
  }

  removeSprites() {
    this.stage.removeMany(this.sprites);
    this.sprites = [];
  }

}



// WEBPACK FOOTER //
// ./src/app/services/remove-windows-doors.service.ts